import {
  createStyleField,
  createMarginFields,
  createPaddingFields,
  createFontFields,
  createUnderlineFields,
  createStyleStateFields,
} from '../../../../utils/create-style-field';

export const manifestReservedWords: string[] = [
  'title',
  'item',
  'asset',
  'underline',
];

const manifest = {
  plugin_id: 4039,
  identifier: 'button_cell',
  name: 'Button Cell',
  description: 'Button Cell plugin for Web',
  type: 'cell_builder',
  api: {},
  dependency_repository_url: [],
  dependency_name: '',
  author_name: 'Applicaster',
  author_email: 'zapp@applicaster.com',
  screen: false,
  react_native: true,
  ui_builder_support: true,
  whitelisted_account_ids: [],
  deprecated_since_zapp_sdk: '',
  unsupported_since_zapp_sdk: '',
  targets: ['web'],
  ui_frameworks: ['quickbrick'],
  platform: 'web',
  manifest_version: '0.0.3',
  dependency_version: '0.0.1',
  min_zapp_sdk: '0.0.1',
  general: {
    fields: [],
  },
  styles: {
    fields: [
      {
        group: true,
        label: 'Asset',
        fields: [
          {
            key: 'asset_switch',
            label: 'Enable',
            type: 'switch',
            initial_value: false,
          },
          {
            key: 'asset_image_key',
            label: 'Data key',
            type: 'text_input',
            initial_value: 'image_base',
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          },
          createStyleField({
            key: 'asset',
            label: 'Width',
            type: 'width',
            initial_value: 20,
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          }),
          createStyleField({
            key: 'asset',
            label: 'Height',
            type: 'height',
            initial_value: 20,
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          }),
          {
            key: 'asset_default',
            label: 'Default asset',
            type: 'uploader',
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          },
          {
            key: 'asset_hover_switch',
            label: 'Enable hover asset',
            type: 'switch',
            initial_value: false,
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          },
          {
            key: 'asset_hover_image_key',
            label: 'Hover Image Data key',
            type: 'text_input',
            initial_value: 'thumb_1',
            conditional_fields: [
              { key: 'styles/asset_hover_switch', condition_value: true },
            ],
          },
          {
            key: 'asset_hover',
            label: 'Hover asset',
            type: 'uploader',
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
              // { key: 'styles/asset_hover_switch', condition_value: true },
            ],
          },
          {
            key: 'asset_selected_switch',
            label: 'Enable selected asset',
            type: 'switch',
            initial_value: false,
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          },
          {
            key: 'asset_selected_image_key',
            label: 'Selected Image Data key',
            type: 'text_input',
            initial_value: 'thumb_2',
            conditional_fields: [
              { key: 'styles/asset_selected_switch', condition_value: true },
            ],
          },
          {
            key: 'asset_selected',
            label: 'Selected asset',
            type: 'uploader',
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
              // { key: 'styles/asset_selected_switch', condition_value: true },
            ],
          },
          {
            key: 'asset_selected_hover_switch',
            label: 'Enable selected & hover asset',
            type: 'switch',
            initial_value: false,
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          },
          {
            key: 'asset_selected_hover_image_key',
            label: 'Selected Hover Image Data key',
            type: 'text_input',
            initial_value: 'thumb_3',
            conditional_fields: [
              {
                key: 'styles/asset_selected_hover_switch',
                condition_value: true,
              },
            ],
          },
          {
            key: 'asset_selected_hover',
            label: 'Selected & hover asset',
            type: 'uploader',
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
              // {
              //   key: 'styles/asset_selected_hover_switch',
              //   condition_value: true,
              // },
            ],
          },
          {
            key: 'asset_alignment',
            label: 'Alignment',
            type: 'select',
            options: [
              { text: 'Left', value: 'left' },
              { text: 'Right', value: 'right' },
            ],
            initial_value: 'left',
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          },
          ...createMarginFields({
            key: 'asset',
            label: '',
            initial_values: {
              margin_top: 0,
              margin_right: 6,
              margin_bottom: 0,
              margin_left: 0,
            },
            conditional_fields: [
              { key: 'styles/asset_switch', condition_value: true },
            ],
          }),
        ],
      },
      {
        group: true,
        label: 'Title',
        fields: [
          {
            key: 'title_switch',
            label: 'Enable',
            type: 'switch',
            initial_value: true,
          },
          {
            key: 'title_data_key',
            label: 'Data key',
            tooltip:
              'What data key from feed entry should be rendered in this field.',
            type: 'select',
            options: [
              {
                text: 'summary',
                value: 'summary',
              },
              {
                text: 'title',
                value: 'title',
              },
              {
                text: 'published',
                value: 'published',
              },
              {
                text: 'updated',
                value: 'updated',
              },
              {
                text: 'author.name',
                value: 'author.name',
              },
              {
                text: 'extensions.section',
                value: 'extensions.section',
              },
              {
                text: 'other',
                value: 'other',
              },
            ],
            initial_value: 'title',
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
            ],
          },
          {
            key: 'title_custom_data_key',
            label: 'Custom data key',
            type: 'text_input',
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
              // {
              //   key: 'styles/title_data_key',
              //   condition_value: 'other',
              // },
            ],
            initial_value: null,
          },
          ...createStyleStateFields({
            key: 'title',
            label: 'font color',
            type: 'font_color',
            initial_value: 'rgba(239, 239, 239, 1)',
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
            ],
          }),
          ...createFontFields({
            key: 'title',
            label: '',
            initial_values: {
              font_family: 'Ubuntu-Medium',
              font_size: 14,
              line_height: 20,
              letter_spacing: 0,
            },
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
            ],
          }),
          {
            key: 'title_text_transform',
            label: 'Text transform',
            type: 'select',
            options: [
              {
                text: 'Default',
                value: 'default',
              },
              {
                text: 'Uppercase',
                value: 'uppercase',
              },
              {
                text: 'Lowercase',
                value: 'lowercase',
              },
              {
                text: 'Capitalize',
                value: 'capitalize',
              },
            ],
            initial_value: 'default',
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
            ],
          },
          {
            key: 'title_text_decoration',
            label: 'Default text decoration',
            type: 'select',
            options: [
              { text: 'None', value: 'none' },
              { text: 'Underline', value: 'underline' },
              { text: 'Strikethrough', value: 'line-through' },
            ],
            initial_value: 'none',
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
            ],
          },
          {
            key: 'title_text_decoration_hover',
            label: 'Hover text decoration',
            type: 'select',
            options: [
              { text: 'None', value: 'none' },
              { text: 'Underline', value: 'underline' },
              { text: 'Strikethrough', value: 'line-through' },
            ],
            initial_value: 'none',
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
            ],
          },
          {
            key: 'title_text_decoration_selected',
            label: 'Selected text decoration',
            type: 'select',
            options: [
              { text: 'None', value: 'none' },
              { text: 'Underline', value: 'underline' },
              { text: 'Strikethrough', value: 'line-through' },
            ],
            initial_value: 'none',
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
            ],
          },
          {
            key: 'title_text_decoration_selected_hover',
            label: 'Selected & hover text decoration',
            type: 'select',
            options: [
              { text: 'None', value: 'none' },
              { text: 'Underline', value: 'underline' },
              { text: 'Strikethrough', value: 'line-through' },
            ],
            initial_value: 'none',
            conditional_fields: [
              {
                key: 'styles/title_switch',
                condition_value: true,
              },
            ],
          },
        ],
      },
      {
        group: true,
        label: 'Button Styling',
        fields: [
          ...createUnderlineFields({
            key: 'item',
            label: 'Item',
            initial_values: {
              underline_background_color: 'transparent',
              underline_background_color_hover: 'transparent',
              underline_background_color_selected: 'transparent',
              underline_background_color_selected_hover: 'transparent',
              underline_thickness: 0,
              underline_corner_radius: 0,
            },
          }),
          ...createMarginFields({
            key: 'item',
            label: 'Item',
            initial_value: 0,
          }),
          ...createPaddingFields({
            key: 'item',
            label: 'Item',
            initial_values: {
              padding_top: 14,
              padding_right: 20,
              padding_bottom: 14,
              padding_left: 20,
            },
          }),
          ...createStyleStateFields({
            key: 'item',
            label: 'item background color',
            type: 'background_color',
            initial_values: {
              default: 'rgba(254, 20, 72, 1)',
              hover: 'rgba(213, 8, 54, 1)',
              selected: 'rgba(254, 20, 72, 1)',
              selected_hover: 'rgba(213, 8, 54, 1)',
            },
          }),
          ...createStyleStateFields({
            key: 'item',
            label: 'item border color',
            type: 'border_color',
            initial_value: 'transparent',
          }),
          createStyleField({
            key: 'item',
            label: 'Item border thickness',
            type: 'border_thickness',
            initial_value: 0,
          }),
          createStyleField({
            key: 'item',
            label: 'Item corner radius',
            type: 'border_radius',
            initial_value: 0,
          }),
        ],
      },
    ],
  },
  localizations: {
    fields: [
      /* TODO: add localization fields */
    ],
  },
} as const;

export default manifest;
